(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.lastScrollTop = 0;
      this.headerState = 'reset';
      this.ticking = false;
      this.scrollThreshold = 12;
      this.preventReveal = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerBounds = {};

      this.setHeaderHeight();

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.onScrollHandler = () => {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      };

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    handleScroll() {
      const scrollTop = this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollDelta = scrollTop - this.lastScrollTop;
      const passedHeader = scrollTop > (this.headerBounds.bottom || 0);

      if (!passedHeader) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
        this.lastScrollTop = scrollTop;
        return;
      }

      this.header.classList.add('scrolled-past-header');

      if (Math.abs(scrollDelta) < this.scrollThreshold) {
        return;
      }

      if (scrollDelta > 0) {
        if (!this.preventHide) {
          this.hide();
        }
      } else {
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 120);
          this.hide();
        }
      }

      this.lastScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.headerState === 'hidden') return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.headerState = 'hidden';
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.headerState === 'revealed') return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.headerState = 'revealed';
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.headerState === 'reset') return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.headerState = 'reset';
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
